export default __webpack_public_path__ + "media/images/user_photos/145-1b35a6c9d4225a8607fddd123051c5b0.jpg";